/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClaimEvidenceControllerFindOneQueryResponse, ClaimEvidenceControllerFindOnePathParams, ClaimEvidenceControllerFindOneQueryParams, ClaimEvidenceControllerFindOne400, ClaimEvidenceControllerFindOne401, ClaimEvidenceControllerFindOne403, ClaimEvidenceControllerFindOne404 } from "../../models/checklistsController/ClaimEvidenceControllerFindOne";

function getClaimEvidenceControllerFindOneUrl(id: ClaimEvidenceControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-application-claim-evidence/${id}` as const }  
  return res
}

/**
 * @summary Get a specific claim evidence row by ID
 * {@link /api/v1/checklist-application-claim-evidence/:id}
 */
export async function claimEvidenceControllerFindOne(id: ClaimEvidenceControllerFindOnePathParams["id"], params?: ClaimEvidenceControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ClaimEvidenceControllerFindOneQueryResponse, ResponseErrorConfig<ClaimEvidenceControllerFindOne400 | ClaimEvidenceControllerFindOne401 | ClaimEvidenceControllerFindOne403 | ClaimEvidenceControllerFindOne404>, unknown>({ method : "GET", url : getClaimEvidenceControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}